<template>
  <div class="wrap">
    <h1 class="common-header">{{ $t('i18n.b553a35f11054343a2e9e60a97266006') }}</h1>
    <div style="margin-top: 20px">
      <el-form :inline="true">
        <el-form-item :label="$t('142')">
          <el-input
            class="search_name"
            v-model="queryModel.search_name"
            :placeholder="`${$t('22')}、${$t('25')}、${$t('825')}`"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('307')">
          <el-date-picker
            v-model="defaultTime"
            type="daterange"
            format="yyyy-MM-dd"
            valueFormat="yyyy-MM-dd"
            range-separator="-"
            :start-placeholder="$t('407')"
            :end-placeholder="$t('408')"
            :picker-options="pickerOptions"
            @change="handlerInputChange"
          />
        </el-form-item>
        <el-form-item :label="$t('27')">
          <el-popover v-model="popover" ref="orgPopover" placement="bottom-start" trigger="click">
            <dep-tree v-show="popover" @node-click="handleNodeClick" />
          </el-popover>
          <el-input
            :value="department_name"
            clearable
            v-popover:orgPopover
            :placeholder="$t('877')"
            @clear="handleNodeClick(null)"
          />
        </el-form-item>
        <el-form-item :label="$t('24')">
          <job v-model="queryModel.job_title_id" />
        </el-form-item>
        <!-- 在职状态 -->
        <el-form-item :label="$t('state')">
          <el-select v-model="queryModel.states" :placeholder="$t('405')" multiple clearable collapse-tags>
            <el-option v-for="item in jobState" :key="item.key" :label="item.value" :value="item.key"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button :loading="queryLoading" type="primary" @click="handleQuery">{{ $t('69') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="exportLoading"
            icon="el-icon-download"
            @click="handleExport"
            v-if="$p('menu.work.punch-record.export')"
            >{{ $t('68') }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="data-table">
      <el-table :data="punchRecordList" style="width: 100%" @sort-change="handleSortChange">
        <el-table-column
          prop="staff_name"
          :label="$t('22')"
          width="200"
          fixed="left"
          sortable="custom"
        ></el-table-column>
        <el-table-column prop="department_name" :label="$t('19')" width="200"></el-table-column>
        <el-table-column prop="job_title_name" :label="$t('24')" width="200"></el-table-column>
        <el-table-column prop="state_txt" :label="$t('prove_1')" width="200"></el-table-column>
        <el-table-column prop="setting_name" :label="$t('1410')" width="200"></el-table-column>
        <el-table-column
          prop="attendance_date"
          :label="$t('i18n.f659cd49c28046feaafe3063fab7c78c')"
          width="200"
          sortable="custom"
        ></el-table-column>
        <el-table-column prop="click_at" :label="$t('1411')" width="200" sortable="custom"></el-table-column>
        <el-table-column prop="click_result" :label="$t('1412')" width="200"></el-table-column>
        <el-table-column prop="click_remark" :label="$t('1414')" width="200"></el-table-column>
        <el-table-column prop="cheat_remark" :label="$t('43f5a937')" width="200">
          <template slot="header">
            <span>{{ $t('43f5a937') }}</span>
            <el-tooltip class="item" effect="dark" :content="$t('831283b3')" placement="right">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="field_remark" :label="$t('i18n.nBgXcZnL0hQN')" width="200"></el-table-column>
        <el-table-column prop="click_address" show-overflow-tooltip :label="$t('1413')" width="200"></el-table-column>
        <el-table-column prop="click_img" :label="$t('1415')" width="200">
          <template slot-scope="scope">
            <template v-if="scope.row.is_show_img">
              <el-image
                :src="scope.row.click_img"
                style="width: 60px; height: 60px; border-radius: 5px"
                fit="cover"
                :preview-src-list="[scope.row.click_img]"
              />
            </template>
            <template v-else>
              <span>{{ scope.row.click_img }}</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="client_name" :label="$t('i18n.7091fe713bb6462b8f6aa54a5a3dc79d')" width="200" />
      </el-table>
    </div>
    <div style="text-align: right">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryModel.page"
        :page-size.sync="queryModel.page_size"
        :page-sizes="[100, 50, 20]"
        :total="totalPage"
        background
        @size-change="getPunchRecordList"
        @current-change="getPunchRecordList"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

import DepTree from '@/components/dep-tree'

import Job from '@/components/jobSelect'

import { sysInfoFn } from 'api/org/per'

function createDefaultTime() {
  const start = dayjs().startOf('month').format('YYYY-MM-DD')
  const current = dayjs(new Date().getTime()).format('YYYY-MM-DD')
  return [start, current]
}

const [s, e] = createDefaultTime()

function createQueryModel() {
  return {
    search_name: '',
    // 开始时间
    attendance_start_date: s,
    // 结束时间
    attendance_end_date: e,
    // 页码
    page: 1,
    // 页数
    page_size: 20,
    // 部门id
    department_id: undefined,
    // 职位id
    job_title_id: undefined,
    // 在职状态，默认1在职，3待离职
    states: ['1', '3'],
    // 排序字段
    sort: '',
    // 升序降序（ ascending：升序，descending：降序）
    dir: ''
  }
}

export default {
  components: { DepTree, Job },
  data() {
    return {
      defaultTime: createDefaultTime(),
      queryModel: createQueryModel(),
      department_name: '',
      punchRecordList: [],
      jobState: [],
      totalPage: 0,
      queryLoading: false,
      exportLoading: false,
      popover: false,
      minDate: false,
      /** @description 不限制开始时间 限制选择长度为最多为6个月 */
      pickerOptions: {
        disabledDate: time => {
          const { minDate } = this
          if (!minDate) return false
          return time < minDate - 15552000000 || time > minDate.getTime() + 15552000000
        },
        onPick: params => {
          this.minDate = params.minDate
          if (params.maxDate) this.minDate = false
        }
      }
    }
  },
  created() {
    this.getPunchRecordList()
    this.getJobState()
  },
  methods: {
    getPunchRecordList() {
      return new Promise(resolve => {
        this.$http({
          url: '/web/statistics/attendancelogs',
          params: this.queryModel
        })
          .then(res => {
            this.punchRecordList = res.data.body
            this.totalPage = res.data.count
          })
          .finally(() => {
            resolve()
          })
      })
    },
    getJobState() {
      sysInfoFn().then(res => {
        this.jobState = res.data.state
      })
    },
    async handleQuery() {
      this.queryLoading = true
      await this.getPunchRecordList()
      this.queryLoading = false
    },
    handleExport() {
      this.exportLoading = true
      this.$http({
        url: 'web/statistics/exportattendancelogs',
        data: this.queryModel
      })
        .then(res => {
          window.location.href = res.data
        })
        .finally(() => {
          this.exportLoading = false
        })
    },
    handleSortChange({ prop, order }) {
      this.queryModel.sort = prop
      this.queryModel.dir = order
      this.getPunchRecordList()
    },
    /**@description 日期更改 */
    handlerInputChange(obj) {
      if (!obj) this.minDate = false
      ;[this.queryModel.attendance_start_date, this.queryModel.attendance_end_date] = obj || ['', '']
    },
    handleNodeClick(val) {
      this.department_name = val?.department_name || ''
      this.queryModel.department_id = val?.department_id || ''
      this.popover = false
    }
  }
}
</script>
